import { trackEvent } from './track-event'

export function trackCreateWishlist() {
  trackEvent({
    event: 'create_wishlist',
    event_name: 'user_interaction',
    action: 'click - create-wishlist',
  })
}
